import { render, staticRenderFns } from "./app-features.vue?vue&type=template&id=0ef5b06e&scoped=true"
import script from "./app-features.vue?vue&type=script&lang=js"
export * from "./app-features.vue?vue&type=script&lang=js"
import style0 from "./app-features.vue?vue&type=style&index=0&id=0ef5b06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5b06e",
  null
  
)

export default component.exports